import { Divider } from "antd";
import React from 'react';
import { formatNumber } from "../../../../../util/varibles/global";
import LineInfo from "../LineInfo";

interface IProps {
    className?: string,
    data: {
        avg_weight: number,
        fish_amount: number,
        total_weight: number
    }
}

const AvgAmountTotal: React.FC<IProps> = ({ className, data }) => {
    const { avg_weight, fish_amount, total_weight } = data;

    return <div className={['flex items-center gap-1', className].join(' ')}>
        <LineInfo label="Avg. weight" className="pl-1">
            {formatNumber(Math.round(avg_weight))} gr
        </LineInfo>
        <Divider orientation='vertical' style={{ top: "-3px", height: "18px", borderColor: "#5E6D78" }} />
        <LineInfo label="Amount" className="pl-[2px]">
            {formatNumber(fish_amount)}
        </LineInfo>
        <Divider orientation='vertical' style={{ top: "-3px", height: "18px", borderColor: "#5E6D78" }} />
        <LineInfo label="Total weight" className="pl-[2px]">
            {Math.round(total_weight / 1000) / 1000} t
        </LineInfo>
    </div>;
};

export default AvgAmountTotal;
